// extracted by mini-css-extract-plugin
export default {"Normal_Badge":"Badge_Normal_Badge__PLLLT","IsCart_Badge":"Badge_IsCart_Badge__Ol8Px","Badge":"Badge_Badge__XwwGV"};